<div class="container-fluid">
  <div class="d-sm-flex align-items-center justify-content-between mb-4">
    <h3 class="m-0 font-weight-bold" style="color: #1A355E;">ABONELİKLER</h3>
    <ol class="breadcrumb ">
      <li class="breadcrumb-item active">Tanımlar</li>
      <li class="breadcrumb-item active">Abonelikler</li>
    </ol>
  </div>
  <div class="data-grid">
    <p-table #dt [value]="contracts$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
      styleClass="p-datatable-sm" [rowHover]="true"
      currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
      [globalFilterFields]="['contractNumber','contractTypeName','customerCode','customerName','portalName','serviceName','invoiceDate','notes','reportTag1','serviceUnitPrice','commissionPrice','numberOfTerminals']"
      [responsive]="true" [rowsPerPageOptions]="[5,10,25,50]">
      <ng-template pTemplate="caption">
        <button pButton type="button" class="p-button-info" label="Yeni" routerLink="/contract-add"></button>
        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
          class="p-button-success p-mr-2" pTooltip="Dışa Aktar" tooltipPosition="bottom" label="Dışa Aktar"></button>
        <div style="text-align: right">
          <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
            (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
        </div>

        <div class="text-center" *ngIf="loading">
          <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
          </div>
          <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;" role="status">
          </div>
          <div class="spinner-grow text-secondary" style="width: 3rem; height: 3rem;" role="status">
          </div>
        </div>

      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="contractNumber" [width]="'5%'">No<p-sortIcon field="contractNumber">
            </p-sortIcon>
          </th>
          <th pSortableColumn="customerName" [width]="'10%'">Müşteri<p-sortIcon field="customerName">
            </p-sortIcon>
          </th>
          <th pSortableColumn="dealerName" [width]="'10%'">Bayi<p-sortIcon field="dealerName">
            </p-sortIcon>
          </th>
          <th pSortableColumn="projectName" [width]="'5%'">Proje<p-sortIcon field="projectName">
            </p-sortIcon>
          </th>
          <th pSortableColumn="portalName" [width]="'5%'">Portal<p-sortIcon field="portalName">
            </p-sortIcon>
          </th>

          <th pSortableColumn="serviceName" [width]="'10%'">Hizmet<p-sortIcon field="serviceName">
            </p-sortIcon>
          </th>
          <th pSortableColumn="serviceUnitPrice" [width]="'5%'">Hizmet Bedeli<p-sortIcon field="serviceUnitPrice">
            </p-sortIcon>
          </th>
          <th pSortableColumn="commissionPrice" [width]="'5%'">Kmsyon Bedeli<p-sortIcon field="commissionPrice">
            </p-sortIcon>
          </th>
          <th pSortableColumn="notes" [width]="'10%'">Notlar<p-sortIcon field="notes">
            </p-sortIcon>
          </th>

          <th pSortableColumn="reportTag1" [width]="'10%'">Notlar2<p-sortIcon field="reportTag1">
            </p-sortIcon>
          </th>

          <th pSortableColumn="startDate" [width]="'10%'">Başlangıç Tarihi<p-sortIcon field="startDate">
            </p-sortIcon>
          </th>
          <th pSortableColumn="invoiceDate" [width]="'10%'">Faturalama Tarihi<p-sortIcon field="invoiceDate">
            </p-sortIcon>
          </th>
          <th pSortableColumn="numberOfTerminals" [width]="'5%'">Terminal Sayısı<p-sortIcon field="numberOfTerminals">
            </p-sortIcon>
          </th>
          <th [width]="'10%'">

          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-contracts>
        <tr>
          <td>{{contracts.contractNumber}}</td>
          <td>{{contracts.customerName}}</td>
          <td>{{contracts.dealerName}}</td>
          <td>{{contracts.projectName}}</td>
          <td>{{contracts.portalName}}</td>
          <td>{{contracts.serviceName}}</td>
          <td>{{contracts.serviceUnitPrice | number: '1.0'}} {{contracts.currencyUnit}}</td>
          <td>{{contracts.commissionPrice | number: '1.0'}} {{contracts.currencyUnit}}</td>
          <td>{{contracts.notes}}</td>
          <td>{{contracts.reportTag1}}</td>
          <td>{{contracts.startDate | date : "dd-MM-yyyy"}}</td>
          <td>{{contracts.invoiceDate | date : "dd-MM-yyyy"}}</td>
          <td> <span class="badge badge-dark" style="font-size: 1.2rem;">{{contracts.numberOfTerminals}}</span></td>

          <td>
            <button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-rounded p-button-success"
              pTooltip="Güncelle" tooltipPosition="bottom" routerLink="/contract-update/{{contracts.id}}"></button>
            <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger"
              pTooltip="Sil" tooltipPosition="bottom" (click)="showDeleteModal(contracts.id)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="ABONELİK SİL" [(visible)]="deleteModal" [modal]="true" [style]="{width: '50vw'}" [baseZIndex]="10000"
  [draggable]="false" [resizable]="false">
  <p class="p-m-0">Abonelik ve abonelik terminal ataması silinecek. Bağlı terminaller havuza gönderilecek. Onaylıyor
    musunuz?</p>
  <ng-template pTemplate="footer">
    <p-button (click)="deleteModal=false" label="Vazgeç" styleClass="p-button-dark"></p-button>
    <p-button (click)="deleteContract()" label="Sil" styleClass="p-button-danger"></p-button>
  </ng-template>
</p-dialog>
